export const AuthPolicyFooter = () => {
  const termsLink = 'https://blesk.io/terms';
  const policyLink = 'https://blesk.io/policy';
  return (
    <div className="text-center text-paragraph-sm text-text-primary">
      Используя Blesk, Вы подтверждаете, что соглашаетесь с{' '}
      <a className="text-brand-secondary" href={termsLink}>
        Условиями использования
      </a>{' '}
      и{' '}
      <a className="text-brand-secondary" href={policyLink}>
        Политикой конфиденциальности
      </a>
    </div>
  );
};
